import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import { truncateStr } from '../../helpers/string';

import AiAwardIcon from '../icons/ai-icon-award.svg';
import AiTag from '../general/ai-tag';

const AiResultCard = ({
	handleClose,
	data,
}) => {
	const navigate = useNavigate();

	const handleClick = id => {
		navigate(`/catalog/details/${id}`);
		handleClose();
	};

	return (
		<div
			className="ignite-ai__card ignite-ai__card-result"
			role="presentation"
			onClick={() => handleClick(data.id)}
		>
			<div className="flex-row justify-space-between align-items-start">
				<div className="margin-right-16">
					<div className="ignite-ai__card-result-title">
						{data.name}
						{' - v'}
						{data.version}
					</div>
					<div className="ignite-ai__card-result-status">
						{data.disposition}
					</div>
				</div>
				{data?.governanceGold && (
					<SVG
						src={AiAwardIcon}
						title="Reusable"
						className="ignite-ai__icon-award"
					/>
				)}
			</div>
			<p className="ignite-ai__general-text margin-bottom-none">
				{truncateStr(data.description, 225)}
			</p>
			{data?.tags?.length > 0 && (
				<div className="ignite-ai__tag-container flex-row flex-wrap justify-flex-start">
					{data.tags.map((item, index) => (
						<AiTag
							// eslint-disable-next-line react/no-array-index-key
							index={index}
							label={item}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default AiResultCard;

AiResultCard.propTypes = {
	handleClose: PropTypes.func.isRequired,
	data: PropTypes.shape({
		name: PropTypes.string.isRequired,
		version: PropTypes.string.isRequired,
		disposition: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		tags: PropTypes.arrayOf(PropTypes.string),
		id: PropTypes.number.isRequired,
		governanceGold: PropTypes.bool,
	}).isRequired,
};
